import { DefaultEdge as DefaultEdgeComponent } from './DefaultEdge';
import { BranchEdge as BranchEdgeComponent } from './BranchEdge';

export { DefaultEdgeComponent as DefaultEdge };
export { BranchEdgeComponent as BranchEdge };

export const edgeTypes = {
	default: DefaultEdgeComponent,
	branch: BranchEdgeComponent,
};
